module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Тест")]), _vm._v(" "), _c('div', {
    staticClass: "text-container valign"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/test"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaClickStart($event)
      }
    }
  }, [_c('span', [_vm._v("начать тест")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "decoration-container decoration-container__test"
  }, [_c('div', {
    staticClass: "layer layer__1",
    style: ({
      transform: 'rotate(' + _vm.angle / 3 + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__2",
    style: ({
      transform: 'rotate(-' + _vm.angle / 3 + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle__bg"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__3",
    style: ({
      transform: 'rotate(' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('Item1')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('Item2')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-5-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-7-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-4-1.png",
      "alt": "Item"
    }
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Планируете провести выходные с шампуром в руке?"), _c('br'), _vm._v("Ждете вечер пятницы, чтобы отправиться на дачу и\n                жарить там стейки до воскресенья? В нашем спецпроекте вы узнаете о том, какие рецепты вам подойдут,\n                а также о мерах, которые стоит принять, чтобы ваш организм не испытал белковую (и не только) перегрузку. ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f990340c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TestStart.vue
// module id = 108
// module chunks = 0